import { STATUS_LABELS, STATUS_TONES } from './measurements';
import { formatNumber } from './format';
/**
 * As faixas de status como referencias. Um nivel pode ter mais de uma faixa (a frequencia
 * baixa demais e a alta demais sao ambas "Atenção"), e cada uma vira uma.
 */
export function statusReferences(ranges, unit) {
    return ranges
        .filter((range) => range.level !== 'UNKNOWN' && range.maxValue > range.minValue)
        .map((range) => ({
        from: range.minValue,
        to: range.maxValue,
        color: STATUS_TONES[range.level],
        label: `${STATUS_LABELS[range.level]}: ${formatNumber(range.minValue, 0)} a ${formatNumber(range.maxValue, 0)} ${unit}`
    }));
}
/** A frequencia maxima estimada pela idade - a formula classica, a mesma do app. */
export function maxHeartRate(age) {
    return 220 - age;
}
/** Cinco zonas, da mais leve a mais intensa, em fracao da frequencia maxima - as do app. */
const ZONES = [
    [0.5, 0.6],
    [0.6, 0.7],
    [0.7, 0.8],
    [0.8, 0.9],
    [0.9, 1.0]
];
/** Do frio ao quente: a zona mais intensa e a que chama a atencao. */
const ZONE_COLORS = ['#5B8DEF', '#36C0B0', '#F2C94C', '#F2994A', '#EB5757'];
/**
 * As zonas de treino por idade, limitadas aos trechos em que a pessoa treinava.
 *
 * Sem trecho de treino nao ha zona nenhuma: fora do treino a frequencia de repouso fica
 * abaixo da primeira zona, e desenha-las sobre o dia inteiro diria que a pessoa passou o
 * dia "fora da zona" (decidido em 14/10/2026: so nos trechos de treino).
 */
export function heartRateZoneReferences(age, spans) {
    if (spans.length === 0 || !(age > 0 && age < 120)) {
        return [];
    }
    const max = maxHeartRate(age);
    return ZONES.map(([low, high], index) => {
        const from = Math.floor(max * low);
        const to = Math.floor(max * high);
        return {
            from,
            to,
            color: ZONE_COLORS[index],
            label: `Zona ${index + 1}: ${from} a ${to} bpm (${Math.round(low * 100)}% a ${Math.round(high * 100)}% da máxima)`,
            spans
        };
    });
}
/**
 * Os trechos de treino a partir dos instantes que tem frequencia cardiaca de ATIVIDADE
 * (tipo 205, que o app so grava durante um treino).
 *
 * Cada instante cobre a sua janela (`step`, uma hora ou um minuto); instantes vizinhos se
 * juntam num trecho so.
 */
export function trainingSpans(times, step) {
    const sorted = [...times].sort((left, right) => left - right);
    const spans = [];
    for (const time of sorted) {
        const last = spans[spans.length - 1];
        if (last && time <= last.end) {
            last.end = Math.max(last.end, time + step);
        }
        else {
            spans.push({ start: time, end: time + step });
        }
    }
    return spans;
}
/** A idade em anos completos numa data, a partir de `yyyy-mm-dd...`. */
export function ageOn(birthDate, today = new Date()) {
    if (!birthDate) {
        return undefined;
    }
    const [year, month, day] = birthDate.slice(0, 10).split('-').map(Number);
    if (!year || !month || !day) {
        return undefined;
    }
    let age = today.getFullYear() - year;
    if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) {
        age -= 1;
    }
    return age;
}
//# sourceMappingURL=chart-references.js.map